/** 后台 JSON 编辑对应的库内 JSONB：顶层 schema 转驼峰，blob 内部保持/还原蛇形。 */

// errorData：失败快照 ai_jobs.error_data。抽屉"原始 JSON"要与库内一致，
// 且 public_params 键名必须与规则模板占位符 {timeout_minutes} 对得上，不能转驼峰。
const OPAQUE_JSON_BLOB_KEYS = new Set(['capabilities', 'parameters', 'errorData']);

// 字段名参与转换，字典内部是定价规格（1K / std_no_audio 等），必须原样保留。
const PRICING_MAP_KEYS = new Set(['byParams', 'usdByParams']);

function toCamelCaseKey(key: string): string {
  return key.replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase());
}

function toSnakeCaseKey(key: string, specialKeys: Record<string, string>): string {
  if (specialKeys[key]) {
    return specialKeys[key];
  }

  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([a-zA-Z])([0-9])/g, '$1_$2')
    .toLowerCase();
}

export function camelizeKeys(obj: unknown, opaqueJsonBlobKeys: readonly string[] = []): unknown {
  if (Array.isArray(obj)) {
    return obj.map((item) => camelizeKeys(item, opaqueJsonBlobKeys));
  }

  if (obj !== null && typeof obj === 'object' && !(obj instanceof Date)) {
    return Object.fromEntries(
      Object.entries(obj as Record<string, unknown>).map(([key, value]) => [
        toCamelCaseKey(key),
        OPAQUE_JSON_BLOB_KEYS.has(key) ||
        OPAQUE_JSON_BLOB_KEYS.has(toCamelCaseKey(key)) ||
        PRICING_MAP_KEYS.has(toCamelCaseKey(key)) ||
        opaqueJsonBlobKeys.includes(key) ||
        opaqueJsonBlobKeys.includes(toCamelCaseKey(key))
          ? value
          : camelizeKeys(value, opaqueJsonBlobKeys),
      ])
    );
  }

  return obj;
}

export function normalizeJsonBlobToSnakeCase(
  value: unknown,
  specialKeys: Record<string, string> = {}
): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeJsonBlobToSnakeCase(item, specialKeys));
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, innerValue]) => [
        toSnakeCaseKey(key, specialKeys),
        PRICING_MAP_KEYS.has(toCamelCaseKey(key))
          ? innerValue
          : normalizeJsonBlobToSnakeCase(innerValue, specialKeys),
      ])
    );
  }

  return value;
}
